module.exports = __webpack_public_path__ + "static/media/close-button.2e04f105.svg";